import { handleRowKeyDown } from "./keyboardNavigation"
import { BodyCellType, TableProps } from "./types"
import { TableBodyCell } from "../TableBodyCell"
import { TableBodyRow } from "../TableBodyRow"
import { TableCheckboxCell } from "../TableCheckboxCell"
import { TableDragHandleCell } from "../TableDragHandleCell"
import { TableRadioButtonCell } from "../TableRadioButtonCell"

export type TableBodyProps = Pick<
  TableProps,
  "body" | "cellHeight" | "onLastRowInView" | "keyboardNavigation"
>

export function TableBody({
  body,
  cellHeight,
  onLastRowInView,
  keyboardNavigation,
}: TableBodyProps) {
  return body.rows.map((row, idx) => {
    const isLastRow = idx === body.rows.length - 1
    const isRowSelected = row.cells.some(
      (cell) =>
        (cell.type === BodyCellType.Checkbox ||
          cell.type === BodyCellType.RadioButton) &&
        cell.isChecked
    )
    return (
      <TableBodyRow
        key={row.key}
        onClick={row.onClick}
        onIntersect={isLastRow ? onLastRowInView : undefined}
        isSelected={isRowSelected}
        enableRowHighlighting={body.enableRowHighlighting}
        rowKey={row.key}
        tabIndex={keyboardNavigation ? (idx === 0 ? 0 : -1) : undefined}
        onKeyDown={
          keyboardNavigation
            ? (e) => handleRowKeyDown(e, row, keyboardNavigation.searchInputRef)
            : undefined
        }
      >
        {row.cells.map((cell) => {
          switch (cell.type) {
            case BodyCellType.DragHandle:
              return (
                <TableDragHandleCell
                  key={cell.key}
                  as="td"
                  rowKey={row.key}
                  isDisabled={cell.isDisabled}
                  disabledMessage={cell.disabledMessage}
                />
              )
            case BodyCellType.Checkbox:
              return (
                <TableCheckboxCell
                  key={cell.key}
                  as="td"
                  isChecked={cell.isChecked}
                  onChangeIsChecked={cell.onChangeIsChecked}
                />
              )
            case BodyCellType.RadioButton:
              return (
                <TableRadioButtonCell
                  key={cell.key}
                  as="td"
                  isChecked={cell.isChecked}
                  onChangeIsChecked={cell.onChangeIsChecked}
                />
              )
            default:
              return (
                <TableBodyCell
                  key={cell.key}
                  height={cellHeight}
                  data-testid={cell.testId}
                  hideColumnBorders={body.hideColumnBorders}
                >
                  {cell.content}
                </TableBodyCell>
              )
          }
        })}
      </TableBodyRow>
    )
  })
}
